import { CustomFieldDataType } from "@/enums/CustomFieldDataType";
import { CustomFieldNumericOption } from "@/enums/CustomFieldNumericOption";
import { z } from "zod";

export const FlexRowFieldSchema = z.object({
  id: z.number(),
  label: z.string(),
  dataType: z.nativeEnum(CustomFieldDataType),
  numericFormat: z.nativeEnum(CustomFieldNumericOption).nullable().optional(),
  width: z.number().nullable(),
  decimals: z.number().default(0),
  maxLength: z.number(),
  listValues: z.array(z.string()),
  customField: z.boolean(),
  textValue: z.string().nullable().optional(),
  numericValue: z.number().nullable().optional(),
  dateTimeValue: z.coerce.date().nullable().optional(),
  booleanValue: z.boolean().nullable().optional(),
  scope: z.number(),
  stopPayments: z.boolean(),
  dashboardDisplay: z.boolean(),
});

export const FlexRowTemplateSchema = z.object({
  settingId: z.string(),
  name: z.string(),
  defaultTemplate: z.boolean(),
  fields: z.array(FlexRowFieldSchema),
});

const DashboardFlexRowSchema = z.object({
  label: z.string(),
  date: z.coerce.date(),
  passed: z.boolean(),
  projectId: z.string(),
});

export const TodaysFlexRowsSchema = z.object({
  currentFlexRows: z.array(DashboardFlexRowSchema),
  upcomingFlexRows: z.array(DashboardFlexRowSchema),
});

export const FlexRowFieldListSchema = z.array(FlexRowFieldSchema);
export const FlexRowTemplateListSchema = z.array(FlexRowTemplateSchema);

export type FlexRowField = z.infer<typeof FlexRowFieldSchema>;
export type FlexRowTemplate = z.infer<typeof FlexRowTemplateSchema>;
export type TodaysFlexRows = z.infer<typeof TodaysFlexRowsSchema>;
export type DashboardFlexRow = z.infer<typeof DashboardFlexRowSchema>;
